import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import * as com from '../../Common';
import CodeVerification from "../../Common/components/CodeVerification";
import Spinner from "react-bootstrap/Spinner";
// import "./CoborrowerSignature.css";
import "./CoborrowerSignature.css";
import { Button, Modal, Spin } from "antd";
import {Document, Page, pdfjs} from "react-pdf";
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep';

function blobToURL(blob) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
            const base64data = reader.result;
            resolve(base64data);
        };
    });
}

function base64ToArrayBuffer(base64) {
    const binaryString = atob(base64)
    const len = binaryString.length
    const bytes = new Uint8Array(len)

    for (let i = 0; i < len; ++i) {
        bytes[i] = binaryString.charCodeAt(i)
    }

    return bytes.buffer
}


function PassCodeVerification(props) {
    const [code, setCode] = useState("");
    const [showError, setShowError] = useState(false);
    const [verifyingCode, setVerifyingCode] = useState(false);
    const [showNoValidMessage, setShowNoValidMessage] = useState(false);

    const verifycode = () => {
        setVerifyingCode(true)
        fetch('/auth/verifysignaturepasscode', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Cache: 'no-cache'
            },
            body: JSON.stringify({
                customerid: props.customerid,
                loanid: props.loanid,
                code: code
            })
        }).then(response => {
            if (response.status !== 200) {
                alert("Looks like there was a problem. Status Code: " + response.status + ", Please try again later");
            }
            response.json().then(js => {
                if (js.Status !== "OK"){
                    setVerifyingCode(false)
                    setShowError(true)
                }
                else {
                    setVerifyingCode(false)
                    setShowError(false)
                    props.setCodePassed(true)
                    props.setSignStatus(js.State)
                }
            })
        }
        )
    }

    const showErrorMessage = () => {
        return(
            <div className="d-flex justify-content-center">
                <div style={{ display:"flex",backgroundColor: "#FFE6BF", borderRadius: "4px", padding: "10px", marginTop: "15px", width: "100%", fontSize:"12px" }}>
                    <img style={{ width: "18px", height: "18px", marginRight: "10px" }} src="/images/warningSignYellow.png" />
                    <div>The code you entered is not valid, please try again.</div>
                </div>
                
            </div>
        )
    }
    return(
        <div className="codeVerifyPane">
            <div className="codeVerifyHeader">
                <img style={{width:"115px", height:"42px"}} src="/images/yeeleeLogo.png" alt="Yeelee Capital Logo" />
            </div>
            <div className="codeVerifyBody">
                {!showNoValidMessage?
                    <div className="codeVerifyWrap">
                        <div className="codeVerifyTittle">Hello {props.coborrowerName}! </div>
                        <div className='codeVerifyBodyText'>Please enter the 4-digit verification code provided by the primary borrower to access the application form</div>
                        {verifyingCode ? 
                            <Spinner animation='border' size='lg' /> 
                            :
                            <CodeVerification 
                                value={code} 
                                onChange={
                                    (e) => {
                                        setCode(e)
                                        // if (e.length === 4) {
                                        //     verifycode(e)
                                        // }
                                    }
                                } 
                            />
                        }
                        {showError && showErrorMessage()}
                        <Button className="verifyCodeButton" onClick={verifycode}>Continue</Button>
                        <div className="noValidCode" onClick={()=> setShowNoValidMessage(true)}>I do no have a valid verification code</div>
                    </div>
                    :
                    <div className="codeVerifyWrap">
                        <div className="noValidMessageTitle">Invalid verification code?</div>
                        <div className="noValidMessageText">Please contact the primary borrower for the verification code. They can find it in their email. If they don't see it, please check the spam folder.</div>
                        <div className="noValidMessageText" style={{marginBottom:"40px"}}>For further assistance, please contact us at <span style={{color:"#325CEB"}}>info@yeeleecapital.com</span>.</div>
                        <Button className="closeNoValidMessage" onClick={() => setShowNoValidMessage(false)}>Got it</Button>
                    </div>
                }
            </div>
        </div>
    )
}

const signCoordinates = {
	"page3": {
		"borrower.signature":        {Left: 174.713613, Top: 297.660956, Right: 426.297521, Bottom: 322.994476},
		"borrower.signature.date":   {Left: 501.398118, Top: 300.369410, Right: 584.768128, Bottom: 324.006066},
		"coborrower.signature":      {Left: 174.488605, Top: 335.571043, Right: 426.511312, Bottom: 359.054493},
		"coborrower.signature.date": {Left: 501.398118, Top: 332.093102, Right: 583.314695, Bottom: 357.771778},
	},
	"page10": {
		"borrower.signature":        {Left: 169.238363, Top: 698.083528, Right: 426.371229, Bottom: 718.467437},
		"borrower.signature.date":   {Left: 501.722242, Top: 695.090383, Right: 578.803180, Bottom: 717.591487},
		"coborrower.signature":      {Left: 174.377535, Top: 730.113396, Right: 425.773533, Bottom: 751.251198},
		"coborrower.signature.date": {Left: 500.705960, Top: 727.736180, Right: 577.566844, Bottom: 751.094632},
	},
	"page11": {
		"borrower.signature":        {Left: 171.660695, Top: 692.688264, Right: 434.979338, Bottom: 716.316112},
		"borrower.signature.date":   {Left: 499.969273, Top: 692.079133, Right: 590.325586, Bottom: 717.496488},
		"coborrower.signature":      {Left: 173.191246, Top: 724.722401, Right: 427.566627, Bottom: 751.340553},
		"coborrower.signature.date": {Left: 501.973388, Top: 721.516240, Right: 589.782424, Bottom: 751.333549},
	},
	"page13": {
		"borrower.signature":         {Left: 173.764603, Top: 546.621688, Right: 429.373279, Bottom: 570.012715},
		"borrower.signature.date":    {Left: 501.355434, Top: 549.019667, Right: 577.191431, Bottom: 570.918362},
		"coborrower.signature":       {Left: 174.115692, Top: 582.866870, Right: 426.994874, Bottom: 604.855493},
		"coborrower.signature.date":  {Left: 502.355124, Top: 580.538820, Right: 577.404020, Bottom: 605.263537},
	},
}
const PT_PX_RATIO = 1.46;

let signMarks = [
    {
        page: 2,
        signid: "page3signature",
        pageName: "page3",
        type: 'signature',
        key: "borrower.signature",
        style: {
        }
    },
    {
        page: 2,
        signid: "page3signature",
        pageName: "page3",
        type: 'date',
        key: "borrower.signature.date",
        style: {
        }
    },
    {
        page: 9,
        signid: "page10signature",
        pageName: "page10",
        type: 'signature',
        key: "borrower.signature",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 9,
        signid: "page10signature",
        pageName: "page10",
        type: 'date',
        key: "borrower.signature.date",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 10,
        signid: "page11signature",
        pageName: "page11",
        type: 'signature',
        key: "borrower.signature",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 10,
        signid: "page11signature",
        pageName: "page11",
        type: 'date',
        key: "borrower.signature.date",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 12,
        signid: "page13signature",
        pageName: "page13",
        type: 'signature',
        key: "borrower.signature",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 12,
        signid: "page13signature",
        pageName: "page13",
        type: 'date',
        key: "borrower.signature.date",
        style: {
            top: 0,
            left: 0,
        }
    },
]
let cosignMarks = [
    {
        page: 2,
        signid: "page3cosignature",
        pageName: "page3",
        type: 'signature',
        key: "coborrower.signature",
        style: {
        }
    },
    {
        page: 2,
        signid: "page3cosignature",
        pageName: "page3",
        type: 'date',
        key: "coborrower.signature.date",
        style: {
        }
    },
    {
        page: 9,
        signid: "page10cosignature",
        pageName: "page10",
        type: 'signature',
        key: "coborrower.signature",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 9,
        signid: "page10cosignature",
        pageName: "page10",
        type: 'date',
        key: "coborrower.signature.date",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 10,
        signid: "page11cosignature",
        pageName: "page11",
        type: 'signature',
        key: "coborrower.signature",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 10,
        signid: "page11cosignature",
        pageName: "page11",
        type: 'date',
        key: "coborrower.signature.date",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 12,
        signid: "page13cosignature",
        pageName: "page13",
        type: 'signature',
        key: "coborrower.signature",
        style: {
            top: 0,
            left: 0,
        }
    },
    {
        page: 12,
        signid: "page13cosignature",
        pageName: "page13",
        type: 'date',
        key: "coborrower.signature.date",
        style: {
            top: 0,
            left: 0,
        }
    },
]


export default function CoborrowerSignature() {
    pdfjs.GlobalWorkerOptions.workerSrc =
    `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    const [codePassed, setCodePassed] = useState(false);
    const [pdf, setPdf] = useState(null);
    const [numPages, setNumPages] = useState(null);
    const [docData, setDocData] = useState(null);
    const [loadingDocs, setLoadingDocs] = useState(false);
    const [signAuthorized, setSignAuthorized] = useState(false);
    const [showSignSuccessModal, setShowSignSuccessModal] = useState(false);
    const [showSignDeclineModal, setShowSignDeclineModal] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [primarySignItems, setPrimarySignItems] = useState({});
    const [status, setStatus] = useState("");
    const [signItems, setSignItems] = useState({});
    const [actionCompleted, setActionCompleted] = useState(false);
    const [signStatus, setSignStatus] = useState("");
    const {customerid} = useParams();
    const documentRef = useRef(null);
    const pageRefs = useRef({});
    const containerRef = useRef(null);
    let searchparams = new URLSearchParams(window.location.search);
    let loanid = searchparams.get("loanid")
    let coborrowerFirstName= searchparams.get("firstname")
    let coborrowerLastName= searchparams.get("lastname")
    let coborrowerName = coborrowerFirstName + " " + coborrowerLastName
    const WIDTH = 900

    useEffect(() => {
        if (signStatus === "cosigned"){
            setStatus("submitted")
            setActionCompleted(true)
        }
    }, [signStatus])

    useEffect(() => {
        const fetchData = async () => {
            signMarks = [
                ...signMarks,
                ...cosignMarks
            ]
            if (codePassed) {
                for (const signMark of signMarks) {
                    const { pageName, key } = signMark
                    signMark.style = {
                        top: signCoordinates[pageName][key].Top * PT_PX_RATIO,
                        left: signCoordinates[pageName][key].Left * PT_PX_RATIO,
                        width: (signCoordinates[pageName][key].Right - signCoordinates[pageName][key].Left) * PT_PX_RATIO,
                        height: (signCoordinates[pageName][key].Bottom - signCoordinates[pageName][key].Top) * PT_PX_RATIO,
                    }
                }
        
                let initSignItems = {}
                for (const { pageName, key, type } of signMarks) {
                    if (!(pageName in initSignItems)) {
                        initSignItems[pageName] = {}
                    }
                    if (!(key in initSignItems[pageName])) {
                        initSignItems[pageName][key] = ''
                    }
                }
                setSignItems(initSignItems)
                setLoadingDocs(true);
                try {
                    const response = await fetch("/borrower/docs/hardmoneyloan/receivedformsforcosigner", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Cache: "no-cache"
                        },
                        body: JSON.stringify({
                            customerid: customerid,
                            loanid: loanid
                        })
                    });
    
                    if (response.status !== 200) {
                        if (response.Text.includes("no rows in result set")) {
                            setLoadingDocs(false);
                            alert("Your primary borrower has not yet completed the application form. Please try again later.");
                            return;
                        } else{
                            setLoadingDocs(false);
                            alert("Looks like there was an internal server problem. Status Code: " + response.status + ", Please try again later.");
                            return;
                        }
                    }
    
                    const jsonResponse = await response.json();
                    const docData = await jsonResponse.Doc.Data;
                    const file = base64ToArrayBuffer(docData);
                    const blob = new Blob([file]);
                    const URL =  await blobToURL(blob);
                    setPdf(URL);
                    setLoadingDocs(false);
                } catch (error) {
                    console.error("Error fetching document data:", error);
                    setLoadingDocs(false);
                }
            }
        };
    
        fetchData();
        getPrimarySignItems();
    }, [codePassed, status]);

    function getPrimarySignItems() {
        fetch('/borrower/hardmoneyloan/getprimarysignitems', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Cache: 'no-cache'
            },
            body: JSON.stringify({
                customerid: customerid,
                loanid: loanid
            })
        }).then(response => {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' +
                    response.status);
                return;
            }
            response.json().then(data => {
                setPrimarySignItems(data)
            })
        })
    }

    function submitSignatures(signItems) {
        setSubmitLoading(true)
        fetch(`/borrower/hardmoneyloan/saveyeeleeformwithcosign?loanid=${loanid}&customerid=${customerid}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Cache: "no-cache"
          },
          body: JSON.stringify({signItems})
        }).then(
          response => {
            if (response.status !== 200) {
              console.log('Looks like there was a problem. Status Code: ' +
                response.status);
              return;
            }

            
            setSubmitLoading(false)
            setActionCompleted(true)
            setShowSignSuccessModal(true)
            // setSubmitLoading(false)
            // props.onSubmit(signItems)
          }
        )
          .catch(function (err) {
            console.log('Fetch Error :-S', err);
          });
    }

    function insertSignature() {
        signMarks = [
            ...signMarks,
            ...cosignMarks
        ]
        let newSignItems= JSON.parse(JSON.stringify(signItems))
        for (const {pageName, key, type} of signMarks) {
            if (type === 'signature') {
                if (key === 'coborrower.signature') {
                    newSignItems[pageName][key] = coborrowerName
                }
                if (key === 'borrower.signature') {
                    newSignItems[pageName][key] = primarySignItems.signItems[pageName][key]
                }
            } else if (type === 'date') {
                if (key === 'coborrower.signature.date') {
                    newSignItems[pageName][key] = moment().format('MM/DD/YYYY')
                } else {
                    newSignItems[pageName][key] = primarySignItems.signItems[pageName][key]
                }
            }
        }
        setSignItems(newSignItems)
        setSignAuthorized(true)
        submitSignatures(newSignItems)
    }

    function confirmSuccess() {
        setShowSignSuccessModal(false)
        setStatus("submitted")
    }

    function confirmDecline() {
        setShowSignDeclineModal(false)
        setStatus("declined")
    }

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const onPageLoadSuccess = (page) => {
    };

    return(
        <div className="h-100">
            {/* <div className="signPage-Header">Header</div> */}
            <div className="signPage-Body">
                {!codePassed?
                    <PassCodeVerification 
                        customerid={customerid} 
                        loanid={loanid} 
                        coborrowerName={coborrowerName} 
                        setCodePassed={setCodePassed} 
                        setSignStatus={setSignStatus}
                    />
                    :
                    <div className="PDFPage-pane">
                        <Modal
                            open={showSignSuccessModal}
                            closable={false}
                            className="signSuccessModal"
                            footer={null}
                        >
                            <div className="confirmModalTitle">Signature Submitted</div>
                            <div className="confirmModalBodyText">You have successfully signed the loan application form.</div>
                            <div className="confirmModalBodyText">Once all borrowers review and sign the form, we will send you a confirmation email. The Yeelee Capital team will then promptyly begin processing your loan application.</div>
                            <div className="w-100 d-flex justify-content-center"><Button className="confirmModalBtn" type="primary" onClick={confirmSuccess}>Got it</Button></div>
                        </Modal>
                        <Modal
                            open={showSignDeclineModal}
                            closable={false}
                            className="signDeclineModal"
                            footer={null}
                        >
                            <div className="confirmModalTitle">Signature Declined</div>
                            <div className="confirmModalBodyText">You have declined to sign the loan application form.</div>
                            <div className="confirmModalBodyText">Please contact the primary borrower to make the necessary edits and resubmit the application form.</div>
                            <div className="confirmModalBodyText">If you have any questions or need assistance, please contact us at <span style={{color:"#325CEB"}}>info@yeeleecapital.com</span>.</div>
                            <div className="w-100 d-flex justify-content-center"><Button className="confirmModalBtn" type="primary" onClick={confirmDecline}>Got it</Button></div>
                        </Modal>

                        <div className="PDFPage-topnav">
                            <img style={{position:"absolute", left:"20px"}} src="/images/yeeleeLogo.png" alt="Yeelee Capital Logo" />
                            {status === ""?
                                <div style={{fontSize:"0.95rem"}}>Please review the application form, read the disclosures and consents carefully, and click "Authorize all signatures" to sign the form. </div>
                                :
                            status === "submitted"?
                                <div className="signatureStatus" style={{backgroundColor:"#E1F2E2"}}>Signature Submitted </div>
                                :
                                <div className="signatureStatus" style={{backgroundColor:"#EFEFEF"}}>Signature declined </div>
                            }
                        </div>
                        {!loadingDocs?
                            <div>
                                <center className='pdf-container'>
                                    <Document
                                        className='pdf-content'
                                        file={pdf}
                                        ref={documentRef}
                                        onLoadSuccess={onDocumentLoadSuccess}
                                    >
                                        {Array.from(
                                            new Array(numPages),
                                            (el, index) => (
                                                <Page
                                                    inputRef={ref =>{
                                                        pageRefs.current[index + 1] = ref
                                                    }}
                                                    width={WIDTH}
                                                    key={`page_${index + 1}`}
                                                    pageNumber={index + 1}
                                                    renderTextLayer={false}
                                                    onLoadSuccess={onPageLoadSuccess}
                                                    onRenderSuccess={(props)=>{}}
                                                >
                                                    {!actionCompleted && <div
                                                        className="page-sign-layer"
                                                        style={{
                                                            width: WIDTH,
                                                            marginLeft: -WIDTH/2,
                                                            left: '50%',
                                                        }}
                                                    >
                                                        {cosignMarks.map((signMark, signIdx) => {
                                                            if (signMark.page === index) {
                                                                let signContent = signItems[signMark.pageName][signMark.key]
                                                                if (signMark.type === 'signature') {
                                                                    return <>
                                                                        <div
                                                                            key={signMark.key}
                                                                            className="PDFsign-mark"
                                                                            // onClick={() => openSignPad(signMark.signid)}
                                                                            style={{
                                                                                position: 'absolute',
                                                                                ...signMark.style
                                                                            }}
                                                                        >
                                                                            {!signAuthorized?<div 
                                                                                style={{
                                                                                    backgroundColor: "#EFEFEF",
                                                                                    border: "1px solid #EFEFEF",
                                                                                    borderRadius: "4px",
                                                                                    color: "#616161",
                                                                                    fontSize: "14px",
                                                                                    padding: "8px",
                                                                                    fontWeight: "500",
                                                                                    width: "100%",
                                                                                    height: "99%",
                                                                                }}
                                                                            >
                                                                                Awaiting your signature
                                                                            </div>
                                                                            :
                                                                            <div>{signContent}</div>
                                                                            }
                                                                        </div>
                                                                        {/* { !signContent ? <div
                                                                            className='sign-thumb-wrapper'
                                                                            // onClick={() => openSignPad(signMark.signid)}
                                                                        >
                                                                            <div
                                                                                className='sign-thumb'
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: signMark.style.top,
                                                                                    left: -140,
                                                                                }}
                                                                            >
                                                                                Awating your signature
                                                                            </div>
                                                                            <div
                                                                                className="sign-thumb-triangle"
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: signMark.style.top,
                                                                                    left: -40,
                                                                                }}
                                                                            ></div>
                                                                        </div> : null} */}
                                                                    </>
                                                                } else if (signMark.type === 'date') {
                                                                    return (
                                                                        <div
                                                                            key={signMark.key}
                                                                            className={signMark.type === 'signature' ? "sign-mark" : "sign-mark-date"}
                                                                            // onClick={() => openSignPad(signMark.signid)}
                                                                            style={{
                                                                                position: 'absolute',
                                                                                ...signMark.style
                                                                            }}
                                                                        >
                                                                            {signContent}
                                                                        </div>
                                                                    )
                                                                }
                                                            }
                                                            return null;
                                                        })}
                                                    </div>}
                                                </Page>
                                            ),
                                        )

                                        }
                                    </Document>
                                </center>
                            </div>
                            :
                            <Spinner animation='border' size='lg' />
                        }
                        <div className='PDFPage-bottomnav'>
                            {actionCompleted?
                                ""
                                :
                                <>
                                    <span 
                                        className="declineSign" 
                                        style={{color:"#325CEB", cursor:"pointer"}} 
                                        onClick={() => {
                                            setShowSignDeclineModal(true)
                                            setActionCompleted(true)
                                        }}
                                    >
                                        Decline signatures
                                    </span>
                                    <Button className="authorizeSign" type="primary" onClick={insertSignature}>{submitLoading?<Spin /> :"Authorize all signatures"}</Button>
                                </>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}